var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpError } from './HttpError';
export const defaultTunnel = {
    log: console,
};
export const buildQueryParams = (queryParams) => {
    if (!queryParams)
        return '';
    const reducedQueryParams = Object.entries(queryParams).reduce((accumulator, currentValue) => {
        const [key, value] = currentValue;
        return typeof accumulator === 'string'
            ? `${accumulator}${key}=${value}&`
            : '';
    }, '?');
    return reducedQueryParams.slice(0, -1);
};
export const getEndpoint = (path, queryParams = {}) => `${path}${buildQueryParams(queryParams)}`;
export const parseResponse = (response) => __awaiter(void 0, void 0, void 0, function* () {
    let result;
    const { headers } = response;
    const contentType = headers && headers.get('content-type');
    if (contentType && contentType.indexOf('application/json') > -1) {
        result = yield response.json();
    }
    else {
        result = yield response.text();
    }
    return result;
});
const onSuccess = (response, reqTunnel) => __awaiter(void 0, void 0, void 0, function* () {
    const { status, url } = response;
    const { log } = reqTunnel;
    const result = yield response.json();
    log.info({
        Request: `${url} successful.`,
        CODE: status,
    });
    return result;
});
const throwError = (status, error = {}) => {
    throw new HttpError(error.errorReason ? error.errorReason : 'Unknow error fetching request', error.errorCode, status);
};
const onError = (response, reqTunnel, error) => __awaiter(void 0, void 0, void 0, function* () {
    const { url, status } = response;
    const { log } = reqTunnel;
    const errorMsg = {
        Request: `${url} failed.`,
        CODE: status,
    };
    if (error) {
        log.error(errorMsg, error);
        throw error;
    }
    const parsedResponse = yield parseResponse(response.clone());
    // Return the actual OpenBet error if there is one
    if (typeof parsedResponse !== 'string' && parsedResponse.error) {
        throw throwError(status, parsedResponse.error);
    }
    log.warn(errorMsg);
    throw throwError(status);
});
const onRouteInstructions = (next, endpoint, tunnel, options = {}
//eslint-disable-next-line consistent-return
) => __awaiter(void 0, void 0, void 0, function* () {
    const { log, } = tunnel;
    log.info({
        Request: `${next} started.`,
        info: '`Route Instructions. Request for next target.',
    });
    // This request will cause a 302 to original request but with wrong headers causing an 404 error (CAS issue)
    const req = yield fetch(next, { method: 'GET', credentials: 'include' });
    // This is a expected error caused by CAS, it modifies the header of the original request causing a 404
    // Solution is to request the original request with it's original options and auth cookies already placed by CAS
    if (req.status === 404) {
        log.info({
            Request: `${endpoint} started.`,
            info: '`Route Instructions. Request for original target.',
        });
        // Call to the original request with it's original options
        const newResponse = yield fetch(endpoint, Object.assign({}, options));
        if (newResponse.ok) {
            return onSuccess(newResponse, tunnel);
        }
        return onError(newResponse, tunnel);
    }
    return onError(req, tunnel);
});
const onResponse = (response, reqTunnel, endpoint, options) => __awaiter(void 0, void 0, void 0, function* () {
    // A redirection is made with method GET instead of POST throwing an error.
    // In case is not authenticated, in the 401 error body response, there is a payload with the next target to fetch
    if (response && response.status === 401) {
        const parsedResponse = yield parseResponse(response.clone());
        if (typeof parsedResponse !== 'string' && parsedResponse.next) {
            return onRouteInstructions(parsedResponse.next, endpoint, reqTunnel, options);
        }
    }
    if (response && response.ok) {
        return onSuccess(response, reqTunnel);
    }
    return onError(response, reqTunnel);
});
export function dataProvider(endpoint, options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(endpoint, options);
        const method = options.method || 'GET';
        const reqTunnel = {
            log: console,
            method,
        };
        reqTunnel.log.info({
            method,
            Request: `${endpoint} started.`,
        });
        try {
            return yield onResponse(response, reqTunnel, endpoint, options);
        }
        catch (error) {
            return onError(response, reqTunnel, error);
        }
    });
}
